(function(){
  var root=document.querySelector('[data-pf-disc]'); if(!root) return;
  var MAP={}; try{ MAP=JSON.parse(document.getElementById('pf-map').textContent)||{}; }catch(e){ return; }

  var LABEL={
    'k:whitening':'Yellow Teeth','k:breath':'Bad Breath','k:sens':'Sensitive Teeth','k:plaque':'Plaque Build-Up',
    'i:nha':'Nano-Hydroxyapatite','i:char':'Activated Charcoal','i:prob':'Probiotic','i:sls':'SLS-Free',
    'p:a':'Under ₹250','p:b':'₹250–499','p:c':'₹500–999','p:d':'₹1,000–1,999',
    'p:e':'₹2,000–2,499','p:f':'₹2,500–2,999','p:g':'₹3,000+',
    't:electric_toothbrush':'Electric','t:manual_toothbrush':'Manual','t:brush_heads':'Brush Heads',
    't:kids':'Kids','t:toothpaste':'Toothpaste','t:mouthwash':'Mouthwash','t:freshener_spray':'Freshener Spray',
    't:tongue_cleaner':'Tongue Cleaner','t:serum_strips':'Serum & Strips','t:combos':'Combos'
  };
  var SORTLAB={'manual':'Featured','best-selling':'Bestsellers','price-ascending':'Price: Low to High',
               'price-descending':'Price: High to Low','created-descending':'Recently Added'};

  /* tile label per kind, read off the rendered tiles */
  var TILE={}; root.querySelectorAll('[data-pf-cat]').forEach(function(b){
    TILE[b.getAttribute('data-pf-cat')]=b.querySelector('b').textContent.trim(); });

  var state={tile:'all',f:[],sort:'manual'};
  /* The drawer edits `staged`; the grid only moves on Apply. */
  var staged=[], stagedSort='manual';

  var cards=[];
  function collect(){
    cards=[];
    document.querySelectorAll('.card-product-item, .product-card, [data-ga4-item]').forEach(function(el){
      var card=el.closest('.card-product-item')||el;
      if(cards.some(function(c){return c.el===card;})) return;
      var a=card.querySelector('a[href*="/products/"]'); if(!a) return;
      var m=a.getAttribute('href').match(/\/products\/([^/?#]+)/); if(!m) return;
      var rec=MAP[m[1]]; if(!rec) return;
      cards.push({el:card,rec:rec});
    });
  }

  function has(rec,token){
    var g=token.charAt(0), v=token.slice(2);
    if(g==='p') return rec.p===v;
    return (rec[g]||[]).indexOf(v)>=0;
  }
  /* OR inside a group, AND between groups */
  function matches(rec,s){
    if(s.tile!=='all' && (rec.t||[]).indexOf(s.tile)<0) return false;
    var groups={};
    s.f.forEach(function(t){ (groups[t.charAt(0)]=groups[t.charAt(0)]||[]).push(t); });
    for(var g in groups){
      if(!groups[g].some(function(t){ return has(rec,t); })) return false;
    }
    return true;
  }
  function countWith(over){
    var s={tile:over.tile!==undefined?over.tile:state.tile, f:over.f!==undefined?over.f:state.f};
    return cards.filter(function(c){return matches(c.rec,s);}).length;
  }
  /* Counts stay STABLE: "how many in this tile have this attribute",
     independent of what else is ticked, so nothing jumps as you tick. */
  function countToken(t){ return countWith({f:[t]}); }

  function stage(t){
    var i=staged.indexOf(t);
    i>=0?staged.splice(i,1):staged.push(t);
    paint();
  }
  function showTab(id){
    root.querySelectorAll('[data-pf-tab]').forEach(function(b){
      b.setAttribute('aria-selected', b.getAttribute('data-pf-tab')===id); });
    root.querySelectorAll('[data-pf-panel]').forEach(function(p){
      p.hidden = p.getAttribute('data-pf-panel')!==id; });
  }
  /* Sort is the store's own, so it means one reload. Filters are client-side
     and instant. Apply does whichever is needed, never both. */
  function applyStaged(){
    if(stagedSort!==state.sort){
      var u=new URL(window.location);
      stagedSort==='manual' ? u.searchParams.delete('sort_by') : u.searchParams.set('sort_by',stagedSort);
      state.tile==='all' ? u.searchParams.delete('tile') : u.searchParams.set('tile',state.tile);
      staged.length ? u.searchParams.set('f',staged.join(',')) : u.searchParams.delete('f');
      window.location.assign(u.toString());
      return;
    }
    state.f=staged.slice(); paint(); closeDrawer();
  }
  function cancelStaged(){ staged=state.f.slice(); stagedSort=state.sort; paint(); closeDrawer(); }

  /* A configured group whose rows can never match in this collection hides
     itself, and so does any individual row with nothing behind it. This is
     what keeps the price bands per-collection: a page only shows the bands
     it actually has products in. */
  function pruneGroups(){
    root.querySelectorAll('[data-pf-panel]').forEach(function(panel){
      var g=panel.getAttribute('data-pf-panel');
      if(g==='s') return;
      var any=[].slice.call(panel.querySelectorAll('[data-pf-f]')).some(function(i){
        return countWith({tile:'all',f:[i.getAttribute('data-pf-f')]})>0; });
      var tab=root.querySelector('[data-pf-tab="'+g+'"]');
      if(tab) tab.hidden=!any;
    });
    root.querySelectorAll('[data-pf-f]').forEach(function(i){
      var lab=i.closest('label');
      lab.hidden = countWith({tile:'all',f:[i.getAttribute('data-pf-f')]})===0;
    });
  }

  function paint(){
    var shown=0;
    cards.forEach(function(c){
      var ok=matches(c.rec,state);
      c.el.classList.toggle('pf-hidden-card',!ok);
      if(ok) shown++;
    });

    root.querySelectorAll('[data-pf-cat]').forEach(function(b){
      var k=b.getAttribute('data-pf-cat');
      b.setAttribute('aria-pressed',state.tile===k);
      var n=countWith({tile:k,f:[]});
      b.disabled = n===0 && state.tile!==k;
      b.classList.toggle('pf-cat-empty', n===0);
    });

    root.querySelectorAll('[data-pf-f]').forEach(function(i){
      var t=i.getAttribute('data-pf-f'), n=countToken(t), on=staged.indexOf(t)>=0;
      i.checked=on;
      var lab=i.closest('label');
      lab.classList.toggle('off',!n && !on);
      lab.classList.toggle('pf-on',on);
      lab.querySelector('[data-pf-n]').textContent=n;
    });

    root.querySelectorAll('[data-pf-s]').forEach(function(r){
      var on=stagedSort===r.getAttribute('data-pf-s');
      r.checked=on; r.closest('label').classList.toggle('pf-on',on);
    });

    root.querySelectorAll('[data-pf-tab]').forEach(function(b){
      var g=b.getAttribute('data-pf-tab'), pre=b.getAttribute('data-pf-prefix')||g,
          n=b.querySelector('[data-pf-railn]');
      if(!n) return;
      n.textContent = g==='s'
        ? (stagedSort==='manual' ? '' : '1')
        : (staged.filter(function(t){return t.charAt(0)===pre;}).length || '');
    });

    var badge=root.querySelector('[data-pf-badge]');
    badge.textContent=state.f.length; badge.hidden=!state.f.length;

    var apply=root.querySelector('[data-pf-applyn]');
    if(apply){
      var willShow=countWith({f:staged});
      apply.textContent = stagedSort!==state.sort
        ? 'Apply · '+SORTLAB[stagedSort]
        : 'Apply · '+willShow+' product'+(willShow===1?'':'s');
    }
    var dirty=staged.join(',')!==state.f.join(',')||stagedSort!==state.sort;
    var ap=root.querySelector('.pf-apply'); if(ap) ap.classList.toggle('pf-dirty',dirty);

    var trail=['<b>'+(TILE[state.tile]||'All Products')+'</b>'];
    if(state.f.length) trail.push('<b>'+state.f.map(function(t){return LABEL[t]||t;}).join(' + ')+'</b>');
    root.querySelector('[data-pf-trail]').innerHTML=trail.join('<i>&rsaquo;</i>');
    root.querySelector('[data-pf-back]').hidden=!(state.tile!=='all'||state.f.length);
    root.querySelector('[data-pf-count]').textContent='Showing '+shown+' of '+cards.length+' products';
    root.querySelector('[data-pf-empty]').hidden=shown>0;

    var u=new URL(window.location);
    state.tile==='all'?u.searchParams.delete('tile'):u.searchParams.set('tile',state.tile);
    state.f.length?u.searchParams.set('f',state.f.join(',')):u.searchParams.delete('f');
    state.sort==='manual'?u.searchParams.delete('sort_by'):u.searchParams.set('sort_by',state.sort);
    history.replaceState(null,'',u);
  }

  function setTile(v){
    state.tile=(state.tile===v)?'all':v;
    /* drop any filter this tile has nothing for, so we never dead-end */
    state.f=state.f.filter(function(t){ return countToken(t)>0; });
    staged=state.f.slice();
    paint();
  }
  function back(){ if(state.f.length) state.f=[]; else state.tile='all'; staged=state.f.slice(); paint(); }

  var drawer=root.querySelector('[data-pf-drawer]'), scrim=root.querySelector('[data-pf-scrim]'),
      opener=root.querySelector('[data-pf-open]'), lastFocus=null;
  function firstTab(){
    var t=root.querySelector('[data-pf-tab]:not([hidden])');
    return t?t.getAttribute('data-pf-tab'):'s';
  }
  function openDrawer(){ staged=state.f.slice(); stagedSort=state.sort;
    lastFocus=document.activeElement; drawer.hidden=false; scrim.hidden=false;
    opener.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden';
    showTab(firstTab()); paint();
    var t=drawer.querySelector('[data-pf-tab][aria-selected="true"]'); if(t) t.focus(); }
  function closeDrawer(){ drawer.hidden=true; scrim.hidden=true;
    opener.setAttribute('aria-expanded','false'); document.body.style.overflow='';
    if(lastFocus) lastFocus.focus(); }

  root.addEventListener('change',function(e){
    var i=e.target.closest('[data-pf-f]'); if(i) return stage(i.getAttribute('data-pf-f'));
    var r=e.target.closest('[data-pf-s]'); if(r){ stagedSort=r.getAttribute('data-pf-s'); paint(); }
  });
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-pf-cat],[data-pf-back],[data-pf-reset],[data-pf-open],[data-pf-tab],[data-pf-apply],[data-pf-cancel],[data-pf-scrim],[data-pf-clearall]');
    if(!b||b.disabled) return;
    if(b.hasAttribute('data-pf-tab'))      return showTab(b.getAttribute('data-pf-tab'));
    if(b.hasAttribute('data-pf-open'))     return openDrawer();
    if(b.hasAttribute('data-pf-apply'))    return applyStaged();
    if(b.hasAttribute('data-pf-cancel')||b.hasAttribute('data-pf-scrim')) return cancelStaged();
    if(b.hasAttribute('data-pf-clearall')) { staged=[]; stagedSort='manual'; return paint(); }
    if(b.hasAttribute('data-pf-back'))     return back();
    if(b.hasAttribute('data-pf-reset'))    { state={tile:'all',f:[],sort:state.sort}; staged=[]; return paint(); }
    if(b.hasAttribute('data-pf-cat'))      return setTile(b.getAttribute('data-pf-cat'));
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!drawer.hidden) cancelStaged(); });

  function boot(){
    collect(); if(!cards.length) return;
    var p=new URLSearchParams(location.search);
    if(TILE[p.get('tile')]) state.tile=p.get('tile');
    (p.get('f')||'').split(',').forEach(function(t){ if(LABEL[t]) state.f.push(t); });
    var sb=p.get('sort_by'); if(SORTLAB[sb]) state.sort=sb;
    staged=state.f.slice(); stagedSort=state.sort;
    pruneGroups();
    paint();
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();

  var grid=document.querySelector('#main-collection-product-grid, .collection-products, main');
  if(grid && window.MutationObserver){
    var t; new MutationObserver(function(){ clearTimeout(t); t=setTimeout(function(){ collect(); pruneGroups(); paint(); },120); })
      .observe(grid,{childList:true,subtree:true});
  }
})();
